export default __webpack_public_path__ + "static/media/SemanaNordica_Agenda_Lunes_eng.e51bef09.png";